<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <!-- <v-card> -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" dark @click.prevent="doExpandAll"> <v-icon dark left>mdi-plus-box</v-icon>{{ labels.expandAll }} </v-btn>
            <v-btn text color="primary" dark @click.prevent="doCollapseAll"> <v-icon dark left>mdi-minus-box</v-icon>{{ labels.collapseAll }} </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="itemList"
                    class="elevation-1"
                    :loading="loading"
                    item-key="item"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    show-expand
                  >
                    <template v-slot:item="props">
                      <tr>
                        <td>
                          <v-btn small fab dark :color="props.isExpanded ? 'error' : 'green'" @click="props.expand(!props.isExpanded)"
                            ><v-icon>{{ props.isExpanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon></v-btn
                          >
                        </td>
                        <td>{{ props.item.item }}</td>
                        <td>{{ props.item.itemDesc }}</td>
                        <td>{{ props.item.siLimit }}</td>
                        <td>{{ props.item.gap }}</td>
                        <td>{{ props.item.pd }}</td>
                        <td class="table-action-header">
                          <table-action :rowData="props" query @query="doSelectItem(props.item)"></table-action>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-flex xs12>
                          <v-data-table :headers="subheaders" :items="item.polQuerySubItemList" class="elevation-1">
                            <tr>
                              <td>
                                <span></span>
                              </td>
                              <td class="justify-start align-start">
                                <pre><span style="font-family: Arial; font-size: 15px">{{ item.subItemDesc1}}</span></pre>
                              </td>
                              <td class="justify-start align-start">
                                <pre><span style="font-family: Arial; font-size: 15px">{{ item.subItemDesc6}}</span></pre>
                              </td>
                              <td class="justify-start align-start text-xs-right">
                                <pre><span style="font-family: Arial; font-size: 15px">{{ item.subItemDesc2}}</span></pre>
                              </td>
                              <td class="justify-start align-start text-xs-right">
                                <pre><span style="font-family: Arial; font-size: 15px">{{ item.subItemDesc3}}</span></pre>
                              </td>
                              <td class="justify-start align-start text-xs-right">
                                <pre><span style="font-family: Arial; font-size: 15px">{{ item.subItemDesc4}}</span></pre>
                              </td>
                              <td class="justify-start align-start">
                                <pre><span style="font-family: Arial; font-size: 15px" v-if="item.subItemDesc5 !== 'null'">{{ item.subItemDesc5}}</span></pre>
                              </td>
                              <td></td>
                            </tr>
                          </v-data-table>
                        </v-flex>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex lg4 md4 xs6>
                  <v-subheader class="queryLabel">{{ labels.item }}</v-subheader>
                  <div class="queryValue" v-if="itemForm.item">{{ itemForm.item }}</div>
                  <span class="queryValue" v-else>-</span>
                </v-flex>
                <v-flex lg4 md4 xs6>
                  <v-subheader class="queryLabel">{{ labels.delItem }}</v-subheader>
                  <div class="queryValue" v-if="itemForm.delItem">{{ itemForm.delItem }}</div>
                  <span class="queryValue" v-else>-</span>
                </v-flex>
                <v-flex lg4 md4 xs6>
                  <v-subheader class="queryLabel">{{ labels.emlPct }}</v-subheader>
                  <div class="queryValue" v-if="itemForm.emlPct">{{ itemForm.emlPct }}</div>
                  <span class="queryValue" v-else>-</span>
                </v-flex>
                <v-flex lg4 md4 xs6>
                  <v-subheader class="queryLabel">{{ labels.emlAmt }}</v-subheader>
                  <div class="queryValue" v-if="itemForm.emlAmt">{{ itemForm.emlAmt }}</div>
                  <span class="queryValue" v-else>-</span>
                </v-flex>
                <v-flex lg6 md12 xs12>
                  <v-subheader class="queryLabel">{{ labels.indGrp }}</v-subheader>
                  <span class="queryValue" v-if="itemForm.indGrp">{{ itemForm.indGrp }} - {{ itemForm.indGrpDesc }}</span>
                  <span class="queryValue" v-else>-</span>
                </v-flex>
                <v-flex md12 xs12>
                  <v-subheader class="queryLabel">{{ labels.stdItemTxtRef }}</v-subheader>
                  <div class="queryValue" v-if="itemForm.stdItemTxtRef">{{ itemForm.stdItemTxtRef }}</div>
                  <span class="queryValue" v-else>-</span>
                </v-flex>
                <v-flex xs12>
                  <v-textarea v-if="itemForm.stdItemTxtLn" v-model="itemForm.stdItemTxtLn" :rows="3" readonly></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-ticket-percent</v-icon><span class="headerTitle">{{ labels.discLdg }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap justify-center align-center>
                      <v-flex xs3>
                        <v-subheader class="queryLabel">{{ labels.discLdg }}</v-subheader>
                      </v-flex>
                      <v-flex xs3>
                        <v-subheader class="queryLabel">{{ labels.discLdgPct }}</v-subheader>
                      </v-flex>
                      <v-flex xs3>
                        <v-subheader class="queryLabel">{{ labels.redBalDiscLdg }}</v-subheader>
                      </v-flex>
                      <v-flex xs3> </v-flex>

                      <v-flex xs3>
                        <div class="queryValue">{{ itemForm.discLdg1Desc }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="queryValue">{{ itemForm.discLdg1Pct }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="queryValue"></div>
                      </v-flex>
                      <v-flex xs3>
                        <v-checkbox
                          color="primary"
                          class="ma-0 pa-0"
                          v-model="polMaster.prtDiscLdg1"
                          :label="labels.prtDiscLdg"
                          readonly
                          hide-details
                        />
                      </v-flex>

                      <v-flex xs3>
                        <div class="queryValue">{{ itemForm.discLdg2Desc }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="queryValue">{{ itemForm.discLdg2Pct }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="queryValue">{{ formatYesNo(polMaster.redBalDiscLdg2) }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <v-checkbox
                          color="primary"
                          class="ma-0 pa-0"
                          v-model="polMaster.prtDiscLdg2"
                          :label="labels.prtDiscLdg"
                          readonly
                          hide-details
                        />
                      </v-flex>

                      <v-flex xs3>
                        <div class="queryValue">{{ itemForm.discLdg3Desc }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="queryValue">{{ itemForm.discLdg3Pct }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="queryValue">{{ formatYesNo(polMaster.redBalDiscLdg3) }}</div>
                      </v-flex>
                      <v-flex xs3>
                        <v-checkbox
                          color="primary"
                          class="ma-0 pa-0"
                          v-model="polMaster.prtDiscLdg3"
                          :label="labels.prtDiscLdg"
                          readonly
                          hide-details
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-package-variant-closed</v-icon><span class="headerTitle">{{ labels.benefit }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap justify-center align-center>
                      <v-flex xs12>
                        <v-data-table :headers="benHeaders" :items="itemBenList" class="elevation-1" :loading="loading">
                          <template v-slot:item="row">
                            <tr>
                              <td>{{ row.item.benCode }}</td>
                              <td>{{ row.item.benDesc }}</td>
                              <td>{{ row.item.gapAeFormatted }}</td>
                              <td>{{ row.item.gap }}</td>
                              <td>{{ row.item.premDueAeFormatted }}</td>
                              <td>{{ row.item.premDue }}</td>
                              <td style="text-align: center">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectItemBen(row.item)">
                                      <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ labels.query }}</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-subheader class="queryLabel">{{ labels.benefit }}</v-subheader>
                        <div class="queryValue">{{ itemForm.benCode }} - {{ itemForm.benDesc }}</div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 md4>
                        <v-subheader class="queryLabel">{{ labels.premRatePct }}</v-subheader>
                        <v-checkbox
                          class="ma-0 pa-0"
                          color="primary"
                          v-model="itemForm.premRateAe"
                          :label="itemForm.premRatePct"
                          readonly
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-subheader class="queryLabel">{{ labels.gap }}</v-subheader>
                        <v-checkbox
                          class="ma-0 pa-0"
                          color="primary"
                          v-model="itemForm.gapAe"
                          :label="itemForm.gap"
                          readonly
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-subheader class="queryLabel">{{ labels.premDue }}</v-subheader>
                        <v-checkbox class="ma-0 pa-0" color="primary" v-model="itemForm.premDueAe" :label="itemForm.premDue" readonly hide-details />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-sign-text</v-icon><span class="headerTitle">{{ labels.itemTextTitle }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-tabs v-model="itemTxtTabMenu" slider-color="teal">
                          <v-tab ripple :key="1">{{ labels.itemUppTxt }}</v-tab>
                          <v-tab ripple :key="2">{{ labels.itemLwrTxt }}</v-tab>
                          <v-tab ripple :key="3">{{ labels.itemEndtTxt }}</v-tab>
                          <v-tab ripple :key="4">{{ labels.excTxt }}</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="itemTxtTabMenu">
                          <v-tab-item :key="1">
                            <v-card>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs12>
                                    <v-textarea v-model="itemForm.itemUppTxt" :rows="10" readonly></v-textarea>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item :key="2">
                            <v-card>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs12>
                                    <v-textarea v-model="itemForm.itemLwrTxt" :rows="10" readonly></v-textarea>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item :key="3">
                            <v-card>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs12>
                                    <v-textarea v-model="itemForm.itemEndtTxt" :rows="10" readonly></v-textarea>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item :key="4">
                            <v-card>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs12>
                                    <v-textarea v-model="itemForm.excTxt" :rows="10" readonly></v-textarea>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Item Statistics -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-chart-areaspline</v-icon><span class="headerTitle">{{ labels.itemStatsTitle }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          :headers="polItemStats.headers"
                          :items="polItemStats.items"
                          item-key="statsType"
                          class="elevation-1"
                          :loading="polItemStats.loading"
                          :options.sync="polItemStats.pagination"
                        >
                          <template v-slot:items="row">
                            <tr>
                              <td>{{ row.item.statsType }}</td>
                              <td>{{ row.item.statsTypeDesc }}</td>
                              <td>{{ row.item.statsVal }}</td>
                              <td>{{ row.item.statsValDesc }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 2021-04-14 LYT OS-723 -->
          <!-- Bordereaux Item -->
          <v-expansion-panel v-if="polMaster.dri === false">
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-chart-areaspline</v-icon><span class="headerTitle">{{ labels.bordereauxItem }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12 class="mt-2">
                        <template>
                          <v-data-table
                            :headers="polBordItem.headers"
                            :items="polBordItem.items"
                            :search="search"
                            :footer-props="{ 'items-per-page-options': itemsPerPage }"
                            :options.sync="polBordItem.pagination"
                            :loading="polBordItem.loading"
                            item-key="name"
                            :no-data-text="noDataText"
                          >
                            <template v-slot:item="row">
                              <tr>
                                <td>{{ row.item.bordItemNo }}</td>
                                <td>{{ row.item.cedPolNo }}</td>
                                <td>{{ row.item.comDateFormat }}</td>
                                <td>{{ row.item.expDateFormat }}</td>
                                <td>{{ row.item.si }}</td>
                                <td>{{ row.item.gap }}</td>
                                <td>{{ row.item.premDue }}</td>
                                <td>{{ row.item.comm }}</td>
                                <td style="text-align: center">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon v-on="on" color="primary" text @click.prevent="doSetPolBordItem(row.item)">
                                        <v-icon>mdi-magnify</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>{{ labels.query }}</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </template>
                      </v-flex>
                      <v-flex xs12 v-if="polBordItemForm.bordItemNo !== undefined">
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.bordItemNo }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.bordItemNo }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.cedPolNo }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.comDate }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.comDate }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.expDate }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.contrctMp }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.contrctMp }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.contrctExpDate }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.contrctExpDate }}</div>
                            </v-flex>
                            <v-flex lg12 md12 sm12 xs12>
                              <v-subheader class="queryLabel">{{ labels.name1 }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.name1 }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.si }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.si }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12> </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.premRatePct }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.premRatePct }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.commPct }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.commPct }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.gap }}</v-subheader>
                              <v-checkbox
                                class="ma-0 pa-0"
                                color="primary"
                                v-model="polBordItemForm.gapAe"
                                :label="polBordItemForm.gap"
                                readonly
                                hide-details
                              ></v-checkbox>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.comm }}</v-subheader>
                              <v-checkbox
                                class="ma-0 pa-0"
                                color="primary"
                                v-model="polBordItemForm.commAe"
                                :label="polBordItemForm.comm"
                                readonly
                                hide-details
                              ></v-checkbox>
                            </v-flex>
                            <v-flex lg2 md2 sm2 xs12>
                              <v-subheader class="queryLabel">{{ labels.premDueAep }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.premDueAep }}</div>
                            </v-flex>
                            <v-flex lg4 md4 sm4 xs12>
                              <v-subheader class="queryLabel">{{ labels.premDue }}</v-subheader>
                              <div class="queryValue">{{ polBordItemForm.premDue }}</div>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12> </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice, formatPriceExt } from '@/utils/index'
import { formatYesNo } from '@/utils/boolean'
import * as TableConst from '@/mixins/table'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        expandAll: 'Expand All',
        collapseAll: 'Collapse All',
        query: 'Query',
        item: 'Risk Group / No. / Item',
        delItem: 'Deleted',
        emlPct: 'Estimated Maximum Loss %',
        emlAmt: 'Estimated Maximum Loss Amount',
        stdItemTxtRef: 'Item Standard Text',
        discLdg: 'Discount / Loading',
        discLdgPct: ' % ',
        redBalDiscLdg: 'Reducing Method',
        prtDiscLdg: 'Print on Schedule',
        benefit: 'Benefit',
        premRatePct: 'Benefit Rate %',
        gap: 'Gross Annual Premium',
        premDue: 'Premium Due',
        itemStatsTitle: 'Item Statistics',
        itemTextTitle: 'Item Text',
        itemUppTxt: 'Upper',
        itemLwrTxt: 'Lower',
        itemEndtTxt: 'Endorsement',
        excTxt: 'Excess Text',
        indGrp: 'Industry Group',
        bordereauxItem: 'Bordereaux Item',
        polBordItemDetails: 'Bordereaux Item Details',
        bordItemNo: 'Item No.',
        cedPolNo: 'Reference No.',
        comDate: 'Commence Date',
        expDate: 'Expiry Date',
        si: 'Sum Insured',
        // premRatePct: 'Premium Rate%',
        // gap: 'GAP',
        premDueAep: 'Premium A/E/P',
        // premDue: 'Premium Due',
        commPctAe: undefined,
        commPct: 'Commission Rate%',
        comm: 'Commission',
        contrctMp: 'Contract Maintenance Period (Months)',
        contrctExpDate: 'Contract Expiry Date',
        name1: 'Insured Name'
      },
      loading: false,
      headers: [
        { text: 'Risk Group/Risk/Item', value: 'item' },
        { text: 'Description', value: 'itemDesc' },
        { text: 'Sum Insured / Limit', value: 'siLimit' },
        { text: 'Gross Ann Premium', value: 'gap' },
        { text: 'PD', value: 'pd' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      itemList: [],
      expanded: [],
      subheaders: [
        { text: '', value: 'blankstart', width: '1%' },
        { text: 'UOM', value: 'subItemDesc1', width: '20%' },
        { text: 'Sub-item Description', value: 'subItemDesc6', width: '20%' },
        { text: 'SI / Limit / Sub Limit', value: 'subItemDesc2', align: 'right', width: '1%' },
        { text: 'SI Uplift %', value: 'subItemDesc3', align: 'right', width: '1%' },
        { text: 'Tolerance % (+/-)', value: 'subItemDesc4', align: 'right', width: '1%' },
        { text: 'Unlimited', value: 'subItemDesc5', width: '1%' },
        { text: '', value: 'blankend', width: '1%' }
      ],
      subitems: [],
      itemForm: {
        item: undefined,
        delItem: undefined,
        emlPct: undefined,
        emlAmt: undefined,
        stdItemTxtRef: undefined,
        stdItemTxtLn: undefined,
        discLdg1Desc: undefined,
        discLdg2Desc: undefined,
        discLdg3Desc: undefined,
        discLdg1Pct: undefined,
        discLdg2Pct: undefined,
        discLdg3Pct: undefined,
        benCode: undefined,
        benDesc: undefined,
        premRateAe: undefined,
        premRatePct: undefined,
        gapAe: undefined,
        gap: undefined,
        premDueAe: undefined,
        premDue: undefined,
        itemUppTxt: undefined,
        itemLwrTxt: undefined,
        itemEndtTxt: undefined,
        excTxt: undefined,
        indGrp: undefined,
        indGrpDesc: undefined
      },
      benHeaders: [
        { text: 'Benefit', align: 'left', value: 'benCode' },
        { text: 'Description', value: 'benDesc' },
        { text: 'GAP A/E', value: 'gapAeFormatted' },
        { text: 'GAP', value: 'gap' },
        { text: 'PD A/E/P', value: 'premDueAeFormatted' },
        { text: 'PD', value: 'premDue' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      itemBenList: [],
      itemTxtTabMenu: undefined,
      polItemStats: {
        headers: [
          { text: 'Statistics Type', align: 'left', value: 'statsType' },
          { text: 'Description', value: 'statsTypeDesc' },
          { text: 'Statistics Value', value: 'statsVal' },
          { text: 'Description', value: 'statsValDesc' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        }
      },
      polBordItem: {
        headers: [
          { text: 'Item', value: 'bordItemNo' },
          { text: 'Ref No.', value: 'cedPolNo' },
          { text: 'Commence Date', value: 'comDate' },
          { text: 'Expiry Date', value: 'expDate' },
          { text: 'SI', value: 'si' },
          { text: 'GAP', value: 'gap' },
          { text: 'Prem Due', value: 'premDue' },
          { text: 'Commission', value: 'comm' },
          { text: 'Action', align: 'center', sortable: false, value: '' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        },
        loading: false
      },
      polBordItemForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        bordItemNo: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        comDate: undefined,
        expDate: undefined,
        cedPolNo: undefined,
        si: undefined,
        premRatePct: undefined,
        gapAe: undefined,
        gap: undefined,
        premDueAep: undefined,
        premDue: undefined,
        commPctAe: undefined,
        commPct: undefined,
        commAe: undefined,
        comm: undefined,
        contrctMp: undefined,
        contrctExpDate: undefined,
        name1: undefined
      },
      singleExpand: true
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    doInit() {
      this.getRiskItemList().then(() => {
        this.getSubItemList()
        if (this.itemList.length > 0) {
          this.setItem(this.itemList[0])
        }
      })
    },
    async getRiskItemList() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.itemList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.itemList = []
            data.data.map((item) => {
              const convertItem = {
                item:
                  item.riskGrpNo.toString().padStart(2, '0') +
                  '/' +
                  item.riskNo.toString().padStart(3, '0') +
                  '/' +
                  item.itemNo.toString().padStart(3, '0'),
                riskGrpNo: item.riskGrpNo.toString().padStart(2, '0'),
                riskNo: item.riskNo.toString().padStart(3, '0'),
                itemNo: item.itemNo.toString().padStart(3, '0'),
                itemDesc: item.uomLongDesc,
                siLimit: formatPrice(item.siLimit),
                gap: formatPrice(item.gap),
                pd: formatPrice(item.pd),
                polQuerySubItemList: item.polQuerySubItemList,
                delItem: formatYesNo(item.delItem),
                emlPct: formatPrice(item.emlPct),
                emlAmt: formatPrice(item.emlAmt),
                stdItemTxtRef: item.stdItemTxtRef,
                stdItemTxtLn: item.stdItemTxtLn,
                discLdg1Desc: item.discLdg1Desc,
                discLdg2Desc: item.discLdg2Desc,
                discLdg3Desc: item.discLdg3Desc,
                discLdg1Pct: formatPriceExt(item.discLdg1Pct, 3),
                discLdg2Pct: formatPriceExt(item.discLdg2Pct, 3),
                discLdg3Pct: formatPriceExt(item.discLdg3Pct, 3),
                polItemBenList: item.polItemBenList,
                itemUppTxt: item.itemUppTxt,
                itemLwrTxt: item.itemLwrTxt,
                itemEndtTxt: item.itemEndtTxt,
                excTxt: item.excTxt,
                statsList: item.statsList,
                indGrp: item.indGrp,
                indGrpDesc: item.indGrpDesc,
                polBordItemList: item.polBordItemList // 2021-04-14 LYT OS-723
              }
              this.itemList.push(convertItem)
            })
            this.loading = false
          } else {
            this.itemList = []
            this.loading = false
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getSubItemList() {
      if (this.itemList.length > 0) {
        for (var a = 0; a < this.itemList.length; a++) {
          if (this.itemList[a].polQuerySubItemList !== undefined) {
            this.itemList[a].polQuerySubItemList.map((subItem) => {
              const subItemList = {
                subItemDesc1: subItem.subItemDesc1,
                subItemDesc2: subItem.subItemDesc2,
                subItemDesc3: subItem.subItemDesc3,
                subItemDesc4: subItem.subItemDesc4,
                subItemDesc5: subItem.subItemDesc5,
                subItemDesc6: subItem.subItemDesc6,
                subItemDesc7: subItem.subItemDesc7,
                subItemDesc8: subItem.subItemDesc8
              }
              this.subitems.push(subItemList)
            })
          }
        }
      }
    },
    getExpanded(index) {
      if (index === true) {
        return 'mdi-minus-box'
      } else {
        return 'mdi-plus-box'
      }
    },
    getExpandedColor(index) {
      if (index === true) {
        return 'primary'
      } else {
        return 'red'
      }
    },
    doExpandAll() {
      this.singleExpand = false
      for (let i = 0; i < this.itemList.length; i += 1) {
        const item = this.itemList[i]
        this.expanded.push(item)
      }
    },
    doCollapseAll() {
      this.singleExpand = true
      this.expanded = []
    },
    doSelectItem(data) {
      this.setItem(data)
    },
    setItem(data) {
      this.itemForm.item = data.item
      this.itemForm.delItem = data.delItem
      this.itemForm.emlPct = data.emlPct
      this.itemForm.emlAmt = data.emlAmt
      this.itemForm.stdItemTxtRef = data.stdItemTxtRef
      this.itemForm.stdItemTxtLn = data.stdItemTxtLn
      this.itemForm.discLdg1Desc = data.discLdg1Desc
      this.itemForm.discLdg2Desc = data.discLdg2Desc
      this.itemForm.discLdg3Desc = data.discLdg3Desc
      this.itemForm.discLdg1Pct = data.discLdg1Pct
      this.itemForm.discLdg2Pct = data.discLdg2Pct
      this.itemForm.discLdg3Pct = data.discLdg3Pct
      this.itemForm.itemUppTxt = data.itemUppTxt
      this.itemForm.itemLwrTxt = data.itemLwrTxt
      this.itemForm.itemEndtTxt = data.itemEndtTxt
      this.itemForm.excTxt = data.excTxt
      this.itemForm.indGrp = data.indGrp
      this.itemForm.indGrpDesc = data.indGrpDesc

      this.polItemStats.items = []
      if (data.statsList) {
        data.statsList.map((statistic) => {
          const statisticList = {
            statsType: statistic.statsType,
            statsTypeDesc: statistic.statsTypeDesc,
            statsVal: statistic.statsValue,
            statsValDesc: statistic.statsValueDesc
          }
          this.polItemStats.items.push(statisticList)
        })
      }

      this.getItemBenList(data).then(() => {
        if (this.itemBenList.length > 0) {
          this.setItemBen(this.itemBenList[0])
        } else {
          data = {
            benCode: '',
            benDesc: '',
            premRateAe: false,
            premRatePct: 0.0,
            gapAe: false,
            gap: data.gap,
            premDueAe: false,
            premDue: 0.0
          }
          this.setItemBen(data)
        }
      })

      // 2021-04-14 LYT OS-723
      if (data.polBordItemList) {
        this.displayPolBordItemList(data).then(() => {
          if (this.polBordItem.items.length > 0 && this.polBordItemForm.bordItemNo === undefined) {
            this.doSetPolBordItem(this.polBordItem.items[0])
          }
        })
      } else {
        this.polBordItem.items = []
        this.polBordItemForm.bordItemNo = undefined
      }
    },
    formatYesNo(data) {
      return formatYesNo(data)
    },
    async getItemBenList(data) {
      this.itemBenList = []
      if (data.polItemBenList) {
        data.polItemBenList.map((item) => {
          const itemBenefitList = {
            seqNo: item.seqNo,
            benCode: item.benCode,
            benDesc: item.benDesc,
            premRateAe: item.premRateAe,
            premRatePct: formatPriceExt(item.premRatePct, 5),
            gapAe: item.gapAe,
            gapAeFormatted: this.formatAE(item.gapAe),
            gap: formatPrice(item.gap),
            premDueAe: item.premDueAe,
            // premDueAeFormatted: this.formatAE(item.premDueAe), // lcd_20210203
            premDueAeFormatted: this.formatAE(item.premDueAep), // lcd_20210203
            premDue: formatPrice(item.premDue)
          }
          this.itemBenList.push(itemBenefitList)
        })
      }
    },
    formatAE(data) {
      if (data === true) {
        return 'A'
      } else if (data === 'A') {
        // lcd_20210203
        return 'A'
      } else {
        return 'E'
      }
    },
    doSelectItemBen(data) {
      this.setItemBen(data)
    },
    setItemBen(data) {
      this.itemForm.benCode = data.benCode
      this.itemForm.benDesc = data.benDesc
      this.itemForm.premRateAe = data.premRateAe
      this.itemForm.premRatePct = data.premRatePct
      this.itemForm.gapAe = data.gapAe
      this.itemForm.gap = data.gap
      // this.itemForm.premDueAe = data.premDueAe // lcd_20210203
      this.itemForm.premDueAe = data.premDueAeFormatted === 'A' // lcd_20210203
      this.itemForm.premDue = data.premDue
    },
    async displayPolBordItemList(data) {
      this.polBordItem.items = []
      data.polBordItemList.map((polBordItem) => {
        const polBordItemList = {
          polNo: polBordItem.polNo,
          renCnt: polBordItem.renCnt,
          endtCnt: polBordItem.endtCnt,
          bordItemNo: polBordItem.bordItemNo,
          riskGrpNo: polBordItem.riskGrpNo,
          riskNo: polBordItem.riskNo,
          comDateFormat: formatDisplayDate(polBordItem.comDate),
          expDateFormat: formatDisplayDate(polBordItem.expDate),
          comDate: polBordItem.comDate,
          expDate: polBordItem.expDate,
          cedPolNo: polBordItem.cedPolNo,
          si: formatPrice(polBordItem.si),
          premRatePct: formatPrice(polBordItem.premRatePct),
          gapAe: polBordItem.gapAe,
          gap: formatPrice(polBordItem.gap),
          premDueAep: polBordItem.premDueAep,
          premDue: formatPrice(polBordItem.premDue),
          commPctAe: polBordItem.commPctAe,
          commPct: formatPrice(polBordItem.commPct),
          commAe: polBordItem.commAe,
          comm: formatPrice(polBordItem.comm),
          contrctMp: polBordItem.contrctMp,
          contrctExpDate: formatDisplayDate(polBordItem.contrctExpDate),
          name1: polBordItem.name1,
          newRec: polBordItem.newRec
        }
        this.polBordItem.items.push(polBordItemList)
      })
    },
    doSetPolBordItem(data) {
      this.polBordItemForm.polNo = data.polNo
      this.polBordItemForm.renCnt = data.renCnt
      this.polBordItemForm.endtCnt = data.endtCnt
      this.polBordItemForm.bordItemNo = data.bordItemNo
      this.polBordItemForm.riskGrpNo = data.riskGrpNo
      this.polBordItemForm.riskNo = data.riskNo
      this.polBordItemForm.comDate = data.comDateFormat
      this.polBordItemForm.expDate = data.expDateFormat
      this.polBordItemForm.cedPolNo = data.cedPolNo
      this.polBordItemForm.si = data.si
      this.polBordItemForm.premRatePct = data.premRatePct
      this.polBordItemForm.gapAe = data.gapAe
      this.polBordItemForm.gap = data.gap
      this.polBordItemForm.premDueAep = data.premDueAep
      this.polBordItemForm.premDue = data.premDue
      this.polBordItemForm.commPctAe = data.commPctAe
      this.polBordItemForm.commPct = data.commPct
      this.polBordItemForm.commAe = data.commAe
      this.polBordItemForm.comm = data.comm
      this.polBordItemForm.contrctMp = data.contrctMp
      this.polBordItemForm.contrctExpDate = data.contrctExpDate
      this.polBordItemForm.name1 = data.name1
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policySummarySettings.init !== 1) {
      this.$store.dispatch('policySummaryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
